import createVueComponent from '../createVueComponent';

const ArrowUpRightFromCircle = createVueComponent(
  'ArrowUpRightFromCircleIcon',
  [
    ['path', { d: 'M22 12A10 10 0 1 1 12 2', key: '1fm58d' }],
    ['path', { d: 'M22 2 12 12', key: 'yg2myt' }],
    ['path', { d: 'M16 2h6v6', key: 'zan5cs' }],
  ],
);

export default ArrowUpRightFromCircle;
